<template>
  <a class="navbar-logo" aria-label="Legl logo" href="/dashboard">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="58"
      height="56"
      viewBox="0 0 56 35"
      fill="none"
    >
      <mask
        id="mask0_904_38551"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="2"
        width="56"
        height="32"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M54.7843 2.625H54.7804C52.9521 2.625 51.2593 3.19692 49.879 4.16929C49.7891 4.23265 49.7032 4.33649 49.7032 4.4458V26.5171C49.7032 26.7032 49.8562 26.857 50.0453 26.8583H50.0494C51.883 26.8583 53.5812 26.2865 54.9668 25.3141C55.058 25.2507 55.1251 25.1468 55.1251 25.0376V2.96626C55.1264 2.78017 54.9735 2.62639 54.7843 2.625ZM47.5925 10.3896C47.7709 10.3896 47.9144 10.538 47.9144 10.716L47.9131 12.5326V24.1179C47.9131 25.391 47.7897 26.4606 47.5549 27.3777C46.62 30.0602 44.4269 32.1453 41.6865 32.9208C41.0345 33.0826 40.3116 33.1946 39.5027 33.2459C39.4718 33.2459 39.4413 33.2469 39.4108 33.2479L39.3675 33.2492C39.3514 33.2497 39.3352 33.25 39.3189 33.25C36.2646 33.25 33.551 31.7326 32.0192 29.2821C31.7791 28.8977 32.3385 27.2131 33.0441 27.6124C33.818 28.0493 36.3008 29.3751 38.3665 29.3751C40.4323 29.3751 41.4651 28.7143 41.9977 28.1478C42.5302 27.5503 42.9366 26.4484 42.9366 25.0633V24.5603H42.8736C41.9346 25.7889 40.4323 26.764 38.0218 26.764C34.2339 26.764 30.7275 24.1206 30.7275 19.1156C30.7275 14.1106 34.2339 11.4672 38.0218 11.4672C40.5571 11.4672 42.0164 12.6054 42.8428 13.6548V12.1348C42.8428 12.0295 42.891 11.9298 42.9769 11.8691C44.2767 10.9385 45.8688 10.3896 47.5898 10.3896H47.5925ZM35.8301 19.1479C35.8301 21.2883 37.2385 22.9257 39.4612 22.9257C41.6837 22.9257 43.0614 21.2883 43.0614 19.1479C43.0614 17.04 41.6837 15.4027 39.4612 15.4027C37.2385 15.4027 35.8301 17.0386 35.8301 19.1479ZM27.6892 21.2544C28.1775 20.9793 28.8831 21.7926 28.7046 22.3199C27.3083 24.931 24.5679 26.7058 21.4116 26.7058C17.7188 26.7058 14.5921 24.2714 13.5284 20.9132C13.3768 20.2389 13.295 19.5132 13.295 18.7351C13.295 13.6046 17.0521 10.6767 21.6222 10.6767C26.1936 10.6767 29.3552 13.73 29.3552 18.263C29.3552 19.0183 29.2922 19.9314 29.2922 19.9314H18.3036C18.3426 20.3373 18.4311 20.7014 18.5612 21.0265C18.6967 21.3246 18.8563 21.5768 19.0307 21.7724C19.5457 22.3199 20.5437 22.9592 22.5423 22.9592C24.541 22.9592 26.9421 21.6766 27.6892 21.2544ZM24.6899 17.0681C24.6591 15.6506 23.6262 13.9512 21.5283 13.9512C19.4626 13.9512 18.3976 15.5872 18.3345 17.0681H24.6899ZM11.9976 22.1283C12.07 22.1283 12.1384 22.162 12.18 22.2214C12.9406 23.2962 13.3899 24.6207 13.3899 26.0529V26.0556C13.3899 26.2026 13.2719 26.32 13.1297 26.32L2.17349 26.3456C1.45713 26.347 0.875 25.763 0.875 25.0428V6.59803H0.900521L0.876385 6.59266C0.876385 6.59266 1.661 4.62494 5.67438 4.57093C5.82869 4.56825 5.95748 4.69636 5.95748 4.85152L5.95075 22.0999L5.94135 22.1283H11.9976Z"
          fill="#01B88E"
        />
      </mask>
      <g mask="url(#mask0_904_38551)">
        <rect
          x="0.4375"
          y="2.65875"
          width="55.125"
          height="30.625"
          fill="url(#paint0_linear_904_38551)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_904_38551"
          x1="37.9498"
          y1="71.4747"
          x2="-19.7716"
          y2="39.5342"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#01B88E" />
          <stop offset="0.94" stop-color="#86DBC8" />
        </linearGradient>
      </defs>
    </svg>
  </a>
</template>
